// {{1}}/{{2}}/... -> the wizard's own ordered templateParams (WhatsApp and
// RCS both use this same positional convention — see whatsapp.provider.js's
// buildMessage() and rcs.provider.js's buildVariables()). Left as-is if
// there's no matching param yet.
export function substituteParams(text, params) {
  if (!text) return text;
  return text.replace(/\{\{(\d+)\}\}/g, (match, idx) => {
    const val = params[parseInt(idx, 10) - 1];
    return val !== undefined && val !== '' ? val : match;
  });
}
